export default {
    'PARALELA_E_NAO_EXCLUDENTE': 'Paralela e não excludente',
    'CRITERIOS_DE_SELECAO_DE_TERCEIROS': 'Critérios de Seleção de Terceiros'
}
